export const OIG = "oig";
